import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Quante volte ogni materiale e' usato, su TUTTA la piattaforma.
 *
 * Serve a rispondere a "posso eliminarlo?" prima di ripulire il catalogo.
 *
 * Il conteggio arriva dalla funzione `materials_usage()`, che e' SECURITY
 * DEFINER di proposito: con la RLS normale si vedrebbero solo i layer della
 * propria organizzazione, e un materiale del catalogo globale che io non uso
 * ma che usa un'altra azienda risulterebbe libero. Cancellandolo si
 * romperebbero i preventivi di qualcun altro.
 *
 * Conta anche gli SNAPSHOT delle righe di preventivo ("Copia indipendente"),
 * che citano i materiali senza vincolo di chiave esterna: li' il database non
 * protesterebbe nemmeno, e il preventivo resterebbe con un riferimento morto.
 */
export function useMaterialsUsage() {
  const query = useQuery({
    queryKey: ['materials-usage'],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<Map<string, number>> => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any).rpc('materials_usage');
      if (error) {
        console.warn('[useMaterialsUsage] conteggio non disponibile:', error.message);
        return new Map();
      }
      const m = new Map<string, number>();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      for (const r of (data ?? []) as any[]) {
        if (r?.material_id) m.set(r.material_id, Number(r.uses ?? 0));
      }
      return m;
    },
  });

  return {
    usageMap: query.data ?? new Map<string, number>(),
    isLoading: query.isLoading,
    /** `false` finche' i dati non sono arrivati: meglio non dire "eliminabile" a vuoto. */
    isReady: !query.isLoading && query.data != null,
  };
}
